<template>
  <section class="goods-top-menu">
    <div>
      <b-nav tabs ref="topMenu">
        <b-nav-item :to="{name: 'goodsImport'}" :active="this.$router.currentRoute.name == 'goodsImport'">Импорт
        </b-nav-item>
        <b-nav-item :to="{name: 'goodsExport'}" :active="this.$router.currentRoute.name == 'goodsExport'">Экспорт
        </b-nav-item>
        <b-nav-item :to="{name: 'product'}" :active="this.$router.currentRoute.name == 'product'">Обработка</b-nav-item>
        <b-nav-item :to="{name: 'goodsCategory'}" :active="this.$router.currentRoute.name == 'goodsCategory'">
          Категории
        </b-nav-item>
        <b-nav-item :to="{name: 'goodsAdd'}" :active="this.$router.currentRoute.name == 'goodsAdd'">Добавить товар
        </b-nav-item>
        <b-nav-item :to="{name: 'goodsImportList'}" :active="this.$router.currentRoute.name == 'goodsImportList'">Список
          Импортов
        </b-nav-item>
        <b-nav-item :to="{name: 'goodsDelete'}" :active="this.$router.currentRoute.name == 'goodsDelete'">
          Массовое удаление
        </b-nav-item>
        <b-nav-item :to="{name: 'GoodsMassChange'}" :active="this.$router.currentRoute.name == 'GoodsMassChange'">
          Массовое изменение
        </b-nav-item>
        <b-nav-item :to="{name: 'CategoriesExport'}" :active="this.$router.currentRoute.name == 'CategoriesExport'">
          Export Categories by Brand
        </b-nav-item>
        <b-nav-item :to="{name: 'CategoryMatching'}" :active="this.$router.currentRoute.name == 'CategoryMatching'">
          Category Matching
        </b-nav-item>
      </b-nav>
    </div>
  </section>
</template>

<script>
export default {
  name: "topMenu"
}
</script>

<style scoped>
.goods-top-menu {
  margin-bottom: 20px;
}
</style>